import { validateProps } from '../utils';
export const isValidMeeting = meetingType => validateProps(meetingType, ['id', 'calendarId', 'providerId', 'slot']);
//# sourceMappingURL=Meeting.js.map